import { render, staticRenderFns } from "./Jan22.vue?vue&type=template&id=e51fce5a&scoped=true&"
import script from "./Jan22.vue?vue&type=script&lang=js&"
export * from "./Jan22.vue?vue&type=script&lang=js&"
import style0 from "./Jan22.vue?vue&type=style&index=0&id=e51fce5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51fce5a",
  null
  
)

export default component.exports